<template>
  <McButton
    variant="secondary"
    :text="$t('global.back')"
    icon="icon-outline_arrow-left"
    @click="goBack"
  />
</template>
<script>
import McButton from '@/components/McButton'
export default {
  components: {
    McButton,
  },
  props: {
    href: {
      type: String,
      required: false,
    },
  },
  methods: {
    goBack() {
      if (this.href) {
        return this.$router
          .push({
            path: this.href,
          })
          .catch(() => {})
      }

      return this.$router.go(-1)
    },
  },
}
</script>
